export default __webpack_public_path__ + "static/media/Gas_sensor.a1d674d4.svg";